import { render, staticRenderFns } from "./InvestigationItem.vue?vue&type=template&id=c87ab7fa&"
import script from "./InvestigationItem.vue?vue&type=script&lang=ts&"
export * from "./InvestigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./InvestigationItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports